export const API_URL =
  process.env.API_HOST || 'https://api.gorbilet.dev.wwhw.org';

export const BLOG_DOMAIN =
  process.env.DOMAIN_HOST || 'https://gorbilet.dev.wwhw.org';

export const GB_DOMAIN =
  process.env.DOMAIN_HOST || 'https://gorbilet.dev.wwhw.org';

export const TEPLOHOD_SCRIPT_URL =
  'https://api.teplohod.info/v1/widget/widget.js';
